import { render, staticRenderFns } from "./LoopBarchart.vue?vue&type=template&id=3872d7de&scoped=true&"
import script from "./LoopBarchart.vue?vue&type=script&lang=js&"
export * from "./LoopBarchart.vue?vue&type=script&lang=js&"
import style0 from "./LoopBarchart.vue?vue&type=style&index=0&id=3872d7de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872d7de",
  null
  
)

export default component.exports